
import MediaPopup from '../../Modal/MediaPopup.vue'

export default {
  components: {
    MediaPopup
  },
  props: {
    productAttributes: { type: Array, default: () => [] },
    featureList: { type: Array, default: () => [] },
    hasValidValue: { type: Boolean, default: false },
    dense: { type: Boolean, default: false }
  },
  data() {
    return {
      showEnergyPopup: false,
      fullEnergyLabelUrl: '',
      showProductDataSheetPopup: false,
      productDataSheetUrl: ''
    }
  },
  methods: {
    isContentfulImage(imageUrl) {
      return imageUrl && typeof imageUrl === 'string' && imageUrl.startsWith('//images.ctfassets.net');
    },
    handleEnergyIconClick(feature) {
      if (feature.name === 'EnergyEfficiency') {
        // Get the full energy label URL from product attributes
        const fullEnergyLabel = this.getAttributeValueIfPresent('full-energy-label');
        if (fullEnergyLabel) {
          this.fullEnergyLabelUrl = fullEnergyLabel;
          this.showEnergyPopup = true;
        }
      }
    },
    closeEnergyPopup() {
      this.showEnergyPopup = false;
      this.fullEnergyLabelUrl = '';
    },
    handleEnergyTextClick(feature) {
      if (feature.name === 'EnergyEfficiency') {
        // Get the product data sheet URL from product attributes
        const productDataSheet = this.getAttributeValueIfPresent('product-data-sheet');
        if (productDataSheet) {
          this.productDataSheetUrl = productDataSheet;
          this.showProductDataSheetPopup = true;
        }
      }
    },
    closeProductDataSheetPopup() {
      this.showProductDataSheetPopup = false;
      this.productDataSheetUrl = '';
    },
    getAttributeValueIfPresent(attributeName) {
      const attribute = this.productAttributes.find(attr => attr.name === attributeName);
      const value = attribute?.value;
      return value !== undefined && value !== null ? value : '';
    }
  }
}
